package de.katoonerie.content

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import de.katoonerie.contentful.ContentfulClient
import de.katoonerie.contentful.Homepage
import de.katoonerie.contentful.Page
import de.katoonerie.type.Result
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.dom.Div

@Composable
fun Homepage.Page(
    contentfulClient: ContentfulClient,
    path: String,
    preview: Boolean = false,
    content: @Composable Page.() -> Unit
) {
    val coroutineScope = rememberCoroutineScope()
    var result: Result<Page?> by remember { mutableStateOf(Result.Pending) }

    if (result is Result.Pending) {
        coroutineScope.launch {
            result = contentfulClient.getPageByUrl(path, preview)
        }
    }

    when (val page = result) {
        is Result.Pending -> Loading()
        is Result.Error -> Error()
        is Result.Success<Page?> -> when (page.value) {
            is Page -> Div(attrs = {
            }) {
                content(page.value)
            }

            else -> NotFound()
        }
    }
}
